module.exports = __webpack_public_path__ + "static/img/contact_img_QR02.6dc535c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guanyu/contact_img_QR02.png
// module id = +kMx
// module chunks = 1